import styled from "styled-components"

import { minWidth, maxWidth } from "utils"

import CroppedImage from "components/cropped-image"

export const Wrapper = styled.div`
  position: absolute;
  top: ${({ isTranslucent }) => (isTranslucent ? "-8rem" : 0)};
  width: 100%;
  height: ${({ isTranslucent }) => (isTranslucent ? "69.4rem" : "calc(69.4rem - 8rem)")};

  ${maxWidth.mobile`
    top: ${({ isTranslucent }) => (isTranslucent ? "-6rem" : 0)};
    height: ${({ isTranslucent }) => (isTranslucent ? "50rem" : "calc(50rem - 6rem)")};
  `}
`

export const HeaderImage = styled(CroppedImage)`
  position: fixed;
  width: 100%;
  max-width: 144rem;
  height: ${({ isTranslucent }) =>
    isTranslucent ? "calc(69.4rem - 10rem)" : "calc(69.4rem - 8rem - 10rem)"};
  z-index: -1;

  ${maxWidth.mobile`
    height: ${({ isTranslucent }) =>
      isTranslucent ? "calc(50rem - 10rem)" : "calc(50rem - 6rem - 10rem)"};
  `}
`

export const Overlay = styled.div`
  position: absolute;
  bottom: 10rem;
  left: 0;
  right: 0;
  height: 60%;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.35));
`

export const Title = styled.div`
  position: absolute;
  bottom: 10rem;
  left: 50%;
  width: 100%;
  border-radius: 0.6rem 0.6rem 0 0;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 500;
  line-height: 1.35;
  text-align: center;
  background-color: ${({ background }) => background};
  color: ${({ theme }) => theme.colors.text.primary};

  ${maxWidth.mobile`
    max-width: 34rem;
    padding: 1.7rem 0.6rem;
    transform: translate(-50%, 5rem);
    font-size: 2.8rem;
  `}

  ${minWidth.mobile`
    max-width: 52rem;
    padding: 2.2rem 0.6rem;
    transform: translateX(-50%);
    font-size: 3.2rem;
  `}

  ${minWidth.tablet`
    max-width: 60rem;
    font-size: 3.6rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 78rem;
    font-size: 4rem;
  `}
`

export const Sponsor = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 10rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ background }) => background};

  ${maxWidth.mobile`
    transform: translateY(5rem);
  `}
`

export const SponsoredBy = styled.div`
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.57px;
`

export const SponsorImageWrapper = styled.div`
  width: 23rem;
  height: 3rem;
  margin-bottom: 2.5rem;
`

export const SponsorImagePlaceholder = styled.div`
  width: 23rem;
  height: 3rem;
  margin-bottom: 2.5rem;
`
